export default "__VITE_ASSET__Br0Y7QmD__"